<template>
  <div class="kpt-api-tryitout">
    <b-collapse class="card" :open="false">
      <div class="card-header" slot="trigger" slot-scope="props" role="button">
        <p class="card-header-title">Try it out</p>
        <a class="card-header-icon"><b-icon :icon="props.open ? 'chevron-down' : 'chevron-up'"></b-icon></a>
      </div>
      <div class="card-content">
        <b-field label="Parameters" v-if="parameters && parameters.length">
          <div>
            <div v-for="param, idx in parameters" style="margin-bottom: 8px;">
              <b-input type="text" ref="param.name" :placeholder="param.name" v-model="paramsToSend[param.name]" />
            </div>
          </div>
        </b-field>
        <b-field label="Body" v-if="hasBody(verb)">
          <b-input type="textarea" v-model="jsonToSend"></b-input>
        </b-field>
        <b-field>
          <b-button type="is-primary" size="is-small" @click="executeCall" :loading="executing">Execute</b-button>
        </b-field>
        <pre class="kpt-response-container" v-if="response">{{response}}</pre>
      </div>
    </b-collapse>
  </div>
</template>
<script>
export default {
  name: 'TryItOut',
  data() {
    return {
      isOpen: false,
      jsonToSend: null,
      response: null,
      paramsToSend: {},
      executing: false
    }
  },
  props: {
    path: {
      type: String
    },
    verb: {
      type: String
    },
    parameters: {
      type: Array,
      required: false
    }
  },
  methods: {
    hasBody(verb) {
      switch (verb) {
        case "put":
        case "post":
          return true;
        case "get":
        case "delete":
          return false;
        default:
          return false;
      }
    },
    async executeCall() {
      // build out the parameters if any
      let paramString = '';
      let path = this.path;
      if (Object.keys(this.paramsToSend).includes('id')) {
        path = path.replace('{id}', this.paramsToSend['id']);
      }
      // exceptions for group services' parameter
      if (Object.keys(this.paramsToSend).includes('groupId')) {
        path = path.replace('{groupId}', this.paramsToSend['groupId']);
      }
      if (Object.keys(this.paramsToSend).includes('entityId')) {
        path = path.replace('{entityId}', this.paramsToSend['entityId']);
      }
      for (let key in this.paramsToSend) {
        let value = this.paramsToSend[key];
        if (key != 'id') {
          paramString += paramString == '' ? `?${key}=${value}` : `&${key}=${value}`;
        }
      }
      // concatenate the path and the parameters
      path += paramString;
      // 2. build out the options
      let options = {
        body: this.jsonToSend ? this.jsonToSend : null,
        method: this.verb,
        headers: new Headers({ 'Content-Type': 'application/json' })
      }
      this.executing = true;
      const res = await fetch(path, options);
      this.executing = false;
      if (res.ok) {
        try {
          this.response = await res.json();
        } catch (ex) {
          this.response = await res.text();
        }
      } else {
        this.response = `[${res.status}] ${res.statusText}`;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-api-tryitout {
  padding: 24px 0;

  .kpt-response-container {
    max-height: 600px;
    overflow-y: auto;
  }
}
</style>
